// Routes Imports
import Pages from './pages';


// Merge Routes
const routes = [ ...Pages ];

export { routes };
